import { Service, ServiceCostSummary } from '@anispi-reporting-system/types';
import { KeyboardArrowDown, KeyboardArrowUp } from '@mui/icons-material';
import { Box, Grid, IconButton } from '@mui/material';
import clsx from 'clsx';
import React, { FunctionComponent, useEffect, useState } from 'react';

interface Props {
  dialog?: boolean;
  service: Service;
  serviceCostSummary: ServiceCostSummary;
}

const ResultService: FunctionComponent<Props> = ({ dialog = false, service, serviceCostSummary }) => {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    setOpen(false);
  }, [serviceCostSummary]);

  return (
    <Grid container spacing={1} rowSpacing={1} className={clsx(dialog && 'h-40', 'overflow-y-auto text-lg')}>
      <Grid item xs={4} className="h-12 text-base">
        <p>{service === 'RS' ? 'RS費' : 'RY費'}</p>
      </Grid>
      <Grid item xs={8}>
        <p className="text-right">¥ {serviceCostSummary.serviceCost.toLocaleString()}</p>
      </Grid>
      <Grid item xs={12} className="h-12 text-base">
        <p className="text-right">
          {`( ¥ ${serviceCostSummary.totalBillingAmount.toLocaleString()} - ¥ ${serviceCostSummary.totalTreatmentImprovementPrice.toLocaleString()} ) * ${
            serviceCostSummary.serviceRatio
          } = ¥ ${serviceCostSummary.serviceCost.toLocaleString()}`}
        </p>
      </Grid>
      <Grid item xs={4} className="h-12 text-base">
        <p>請求額合計</p>
      </Grid>
      <Grid item xs={8}>
        <p className="text-right">¥ {serviceCostSummary.totalBillingAmount.toLocaleString()}</p>
      </Grid>
      <Grid item xs={4} className="h-12 text-base">
        <p>処遇改善加算等額合計</p>
      </Grid>
      <Grid item xs={8}>
        <p className="text-right">¥ {serviceCostSummary.totalTreatmentImprovementPrice.toLocaleString()}</p>
      </Grid>

      <Grid item xs={10} className="h-12 text-base">
        <p>(詳細)</p>
      </Grid>
      <Grid item xs={2} className="h-12 text-right">
        <Box>
          <IconButton onClick={() => setOpen(!open)}>{open ? <KeyboardArrowUp /> : <KeyboardArrowDown />}</IconButton>
        </Box>
      </Grid>

      {serviceCostSummary.details.map((detail, index) => (
        // eslint-disable-next-line react/no-array-index-key
        <Grid item xs={12} className={clsx(open === false && 'hidden', 'h-12')} key={index}>
          <p className="text-right">
            ¥ {detail.billingAmount.toLocaleString()}
            {detail.serviceUnits.map((serviceUnit, serviceUnitIndex) => (
              // eslint-disable-next-line react/no-array-index-key
              <span key={serviceUnitIndex}>{` - (${serviceUnit.toLocaleString()} * ${detail.areaPrice})`} </span>
            ))}
            = ¥ {detail.treatmentImprovementPrice.toLocaleString()}
          </p>
        </Grid>
      ))}
    </Grid>
  );
};

export { ResultService };
